import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import styles from './Winners.module.css';
import hum from '../../assets/images/hum.png';
// import { useBroadcast } from '../../hooks/useBroadcast';

import { hideNumber } from '../../helpers/titreHelper';
import confetti from '../../assets/images/confetti-29.gif';

function Winners({ winnerFontSize, winnerMessages }) {
  // const { winnerMessages } = useBroadcast();

  const errorHandler = (e) => {
    e.target.src = hum;
  };

  const confettiRef = useRef(null);
  useEffect(() => {
    let idTimeout = '';

    if (confettiRef.current) {
      idTimeout = setTimeout(() => {
        confettiRef.current.style.display = 'block';
      }, 470);
    }
    return () => {
      clearTimeout(idTimeout);
    };
  }, []);

  return (
    <div className={styles.winnersContainer}>
      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ duration: 0.47, ease: 'easeIn' }}
        className={styles.title}
      >
        {winnerMessages?.length <= 1 ? 'Победитель' : ' Победители'}
      </motion.div>

      <div className={styles.winnersBlock}>
        {winnerMessages &&
          winnerMessages.slice(0, 3).map((win, i) => (
            <motion.div
              key={win.id}
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{
                duration: 0.37,
                delay: 0.47 + i * 0.27,
                ease: 'easeIn',
              }}
              className={styles.m}
            >
              <div className={styles.winnerItem}>
                <img
                  onError={errorHandler}
                  src={
                    (win.message?.image &&
                      win.message.image !== '1' &&
                      win.message.image) ||
                    hum
                  }
                  alt="avatar"
                  className={styles.avatar}
                />
                <div
                  className={styles.author}
                  style={{ fontSize: `${winnerFontSize}rem` }}
                >
                  {win.message?.author || hideNumber(win.message?.senderNumber)}
                </div>
              </div>
            </motion.div>
          ))}
      </div>

      <img
        src={confetti}
        alt="confetti"
        className={styles.confetti}
        ref={confettiRef}
      />
    </div>
  );
}

export default Winners;
